export default __webpack_public_path__ + "static/media/05.4904d584.jpg";